import React, { Fragment } from "react";
import Spinner from "../../../Spinner";
import { Type } from "discover.medical.react-component-library";

const CartSection = ({ showTaxSpinner, plan, taxes, total, error }) => (
  <Fragment>
    <Type element="h2" styledAs="h3" fontFamily="secondary" marginBottom="sm">
      Cart
    </Type>
    <div
      className={`cart bordered container-fluid position-relative ${
        error ? "border-danger" : ""
      }`}
    >
      {plan ? (
        <Fragment>
          <div className="row">
            <div className="col-9">
              <p data-auto="planDescription">{plan.description}</p>
              <p className="ml-4" data-auto="planRenewPolicy">
                Renews annually
              </p>
            </div>
            <div
              className="col-3 text-right font-weight-bold text-nowrap"
              data-auto="planPrice"
            >
              {plan.discountPrice ? (
                <Fragment>
                  <s>
                    <p>${plan.price}</p>
                  </s>
                  <p className="discount-price"> ${plan.discountPrice}</p>
                </Fragment>
              ) : (
                <p>${plan.price}</p>
              )}
            </div>
          </div>
          {(taxes || showTaxSpinner) && (
            <div className="row">
              <div className="col-9 d-flex">
                <span data-auto="taxesTitle">Taxes</span>
              </div>
              <div
                className="col-3 text-right font-weight-bold text-nowrap"
                data-auto="taxesValue"
              >
                {!showTaxSpinner ? (
                  "$" + (taxes || "-")
                ) : (
                  <Spinner className="tax-spinner" />
                )}
              </div>
            </div>
          )}
          <div className="row total-row">
            <div className="col-9 font-weight-bold" data-auto="totalPriceTitle">
              Total (USD)
            </div>
            <div
              className="col-3 text-right font-weight-bold text-nowrap"
              data-auto="totalPrice"
            >
              $ {total || "-"}
            </div>
          </div>
        </Fragment>
      ) : (
        <Spinner className="tax-spinner" />
      )}
    </div>
  </Fragment>
);

export default CartSection;
